import {
    Controller
} from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {

    connect() {
        this.initializeTomSelect();
    }

    // Triggered when the Stimulus controller is removed from the DOM.
    disconnect() {
        this.destroyTomSelect();
    }

    initializeTomSelect() {
        const element = this.element;

        // Return early if no element is associated with the controller.
        if (!element) return;

        element.classList.remove('is-valid');

        // Fetch data for the dropdown.
        const fetchData = (url, search, callback) => {
            fetch(url)
                .then(response => response.json())  // Convert response to JSON.
                .then(data => callback(data))       // Send data to TomSelect.
                .catch(() => callback());           // Handle any errors.
        };

        let userSettings = {
            onChange: function (value) {
                this.blur()
            }
        }

        // for multiple select
        if (this.element.hasAttribute('multiple')) {
            userSettings.plugins = ['remove_button']
            userSettings.onItemAdd = function (_value, _$item) {
                this.setTextboxValue('');
                this.refreshOptions();
            }
        }

        if (this.data.has('url')) {
            userSettings.load = (query, callback) => {
                fetchData(this.data.get('url'), query, callback);
            };
        }

        this.select = new TomSelect(element, userSettings);
    }

    // Cleanup: Destroy the TomSelect instance when the controller is disconnected.
    destroyTomSelect() {
        if (this.select) {
            this.select.destroy();
        }
    }
}
